import { requireAccess } from './permission'

export const travels = [
  {
    path: '/viagens/noticias/:type?/:page?/:id?',
    name: 'TravelsArticles',
    component: () => import('views/verticals/travels/articles/Main'),
    title: 'Artigos',
    icon: 'fa-file-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-travels'
    }
  },
  {
    path: '/viagens/vouchers/:type?/:id?',
    name: 'TravelsVouchers',
    component: () => import('views/verticals/travels/vouchers/Main'),
    title: 'Vouchers',
    icon: 'fa-coupon-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-travels'
    }
  },
  // {
  //   path: '/viagens/temas/:type?/:page?/:id?',
  //   name: 'TravelsThemes',
  //   component: () => import('views/verticals/travels/themes/Main'),
  //   title: 'Temas',
  //   icon: 'fa-tags',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/viagens/autores/:type?/:page?/:id?',
  //   name: 'TravelsAuthors',
  //   component: () => import('views/verticals/travels/authors/Main'),
  //   title: 'Autores',
  //   icon: 'fa-pencil',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/viagens/versions/:type?/:page?/:id?',
  //   name: 'Versions',
  //   component: () => import('views/verticals/travels/versions'),
  //   title: 'Versão dos aplicativos',
  //   icon: 'fa-tablet',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     // {
  //     //   title: 'Cadastrar',
  //     //   type: 'cadastrar',
  //     //   submenu: true
  //     // },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ],
  //   editorAccess: true,
  //   beforeEnter: requireAccess,
  //   meta: {
  //     permission: 'admin-travels'
  //   }
  // },
  {
    path: '/viagens',
    component: () => import('views/verticals/travels/articles/Main')
  }
]



// WEBPACK FOOTER //
// ./src/router/travels.js